module.exports = __webpack_public_path__ + "static/media/unwanted-car-buyers2.7e5567fb.png";